import { WebApiActionGet, WebApiItems } from "components/ajax/WebApi";
import baseUrl from "./url";

export interface ParSz {
    Id: number;
    PartnerClenId: number;
    PartnerIdt: string;
    PartnerJmeno: string;
    PartnerkaClenId: number;
    PartnerkaIdt: string;
    PartnerkaJmeno: string;
    SttAktivni: boolean;
    LatAktivni: boolean;
}

interface Clen {
    Id: number;
    Idt: number;
    Prijmeni: string;
    Jmeno: string;
    KlubId?: number;
}

interface NrtPotvrzeniParu {
    PotvrzSttPartner: number;
    PotvrzLatPartner: number;
    PotvrzKombPartner: number;
    FormularDataPartner: string;

    PotvrzSttPartnerka: number;
    PotvrzLatPartnerka: number;
    PotvrzKombPartnerka: number;
    FormularDataPartnerka: string;
}

interface SttLat {
    Id: number;
    Stav: number;
    RegPar: boolean;
    DatVzniku?: Date;
    DatUkonceni?: Date;
    PartnerDatPotvrz?: Date;
    PartnerkaDatPotvrz?: Date;

    Trida: string;
    Body: number;
    FinaleTuz: number;
    FinaleZahr: number;

    TridaSe: string;
    BodySe: number;
    FinaleTuzSe: number;
    FinaleZahrSe: number;

    RowVersion: string;
}


export interface Par {
    Id: number;
    Partner: Clen;
    Partnerka: Clen;
    Stt: SttLat;
    Lat: SttLat;
    NrtPotvrzParu: NrtPotvrzeniParu;
    VekKtg: string;
    SeniorskyPar: boolean;
    PartnerEdit: boolean;
    PartnerkaEdit: boolean;
    PotvrditNrt: boolean;
}

export const SeznamAktivnichParu = function (): WebApiActionGet<WebApiItems<ParSz>> {
    return new WebApiActionGet<WebApiItems<ParSz>>(baseUrl + 'seznam-aktivnich-paru');
}


export const SeznamPartneru = function (clenId: number): WebApiActionGet<WebApiItems<Par>> {
    return new WebApiActionGet<WebApiItems<Par>>(baseUrl + `seznam-partneru/${clenId}`);
}

export const apiGetPar = function (parId: number, regPar: boolean = null): WebApiActionGet<Par> {
    const url = regPar == null ? baseUrl + `par/${parId}` : baseUrl + `par/${parId}?regPat=true`;
    return new WebApiActionGet<Par>(url);
}

export const apiGetParDetail = function (parId: number, regPar: boolean = null): WebApiActionGet<Par> {
    const url = regPar == null ? baseUrl + `detail/${parId}` : baseUrl + `detail/${parId}?regPat=true`;
    return new WebApiActionGet<Par>(url);
}
